import {takeEvery} from 'redux-saga/effects';
import createAsyncSaga from 'lib/createAsyncSaga';
import {setEditor} from 'lib/api/setEditorJob';
import {setEditJobAction, SAVE_POST} from 'modules/setEditorJob/actions';

const setEditorJobSaga = createAsyncSaga(setEditJobAction, setEditor);

export function* SaveEditorJobSaga() {
  yield takeEvery(SAVE_POST, setEditorJobSaga);
}
